import React from 'react';
import { Tag } from '@trussworks/react-uswds';

export function USWDSTag(props) {
  return <Tag {...props} />;
}
